export const headingTheme = {
    baseStyle: {
        fontFamily: 'fonts',
    },
}
